// resources/js/components/StartpageContent.js

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
// import '../../css/build/app.css';
import '/css/app.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import AnchorLink from "react-anchor-link-smooth-scroll";

/* import p_hongkongcity from '../../img/homepage/HK_Bild_AdobeStock_116977445.jpeg';
import p_display_vuelta from '../../img/homepage/EXP051-Front-Side_v03.jpg';
import p_display_dollar from '../../img/homepage/Dollar_Display_v03.jpg';
import p_ourdisplays from '../../img/homepage/picture_our-displays.png';
import p_effpacked from '../../img/homepage/picture_efficiently-filled-packed-loaded.png';
import p_youchoose from '../../img/homepage/picture_you-choose-what-you-sell.png';
import p_choosefrom1000 from '../../img/homepage/picture_choose-from-1000s-of-items.png';
import p_quality from '../../img/homepage/Quality_Picture_cut_v01.png'; */

import p_hongkongcity from '/images/HK_Bild_AdobeStock_116977445.webp';
import p_display_vuelta from '/images/Mixed_Display.webp';
import p_display_dollar from '/images/Christmas_Display.webp';
import p_ourdisplays from '/images/DisplayBilder.webp';
import p_effpacked_disp from '/images/picture_efficiently-filled-packed-loaded_single-display_v2.webp';
import p_effpacked_contdisp from '/images/picture_efficiently-filled-packed-loaded_container-displays.webp';
import p_youchoose_prodcat from '/images/picture_you-choose-what-you-sell_productcategories.webp';
import p_choosefrom1000_prodall from '/images/picture_choose-from-1000s-of-items_all-products.webp';
import p_quality from '/images/Quality_Picture_cut_v01.webp';

export default function StartpageContent() {
    return (
        <div className="row d-flex justify-content-center">
            
            <div className="col-md-9">
                <div className="">
                    <h1 className="text-center mt-3">Welcome to J. E. Schum (Asia) Limited</h1>
                </div>
                <div className="">
                    <img src={p_hongkongcity} alt="city of Hong Kong" className="w-100"/>
                </div>

                <hr/>
                <div className="d-flex justify-content-between align-items-center row">
                    <div className="col-md-auto">Navigate:</div>
                    {/* <AnchorLink href="#ourdisplays" offset='100' className='text-decoration-none text-reset'>
                        <div className=''><FontAwesomeIcon icon="fa-solid fa-angle-right" className='me-1' />Our displays</div>
                    </AnchorLink> */}
                    <AnchorLink href="#efficientlyfilled" offset='100' className='text-decoration-none text-reset col-md-auto'>
                        <div className=''><FontAwesomeIcon icon="fa-solid fa-angle-right" className='me-1' />Efficiently filled, packed & loaded</div>
                    </AnchorLink>
                    <AnchorLink href="#youchoose" offset='100' className='text-decoration-none text-reset col-md-auto'>
                        <div className=''><FontAwesomeIcon icon="fa-solid fa-angle-right" className='me-1' />Huge available assortment</div>
                    </AnchorLink>
                    <AnchorLink href="#choosefrom" offset='100' className='text-decoration-none text-reset col-md-auto'>
                        <div className=''><FontAwesomeIcon icon="fa-solid fa-angle-right" className='me-1' />Choose from 1000s of items</div>
                    </AnchorLink>
                </div>
                <hr/>
                
                {/* <FontAwesomeIcon icon="coffee" /> */}
                <div className="d-flex justify-content-center mb-5" id="ourdisplays">
                    <img src={p_ourdisplays} className="w-100" alt="half and full display"/>
                </div>
                
                <div className="d-flex justify-content-center mb-3">
                    
                    <div className="col-md-5 col-4">
                        <img src={p_display_vuelta} className="w-100" alt="example display"/>
                    </div>
                    <div className="col-md-2 col-4 d-flex justify-content-center ms-3 me-3" >
                        
                        <div className="d-flex justify-content-center flex-column btn border-secondary btn-light align-self-center" style={{ height: 'fit-content' }}>
                            <Link to="/quality" className='text-decoration-none text-reset'>
                                <div className="align-self-center fw-bold schum-color">
                                    <div>Quality Controlled by Germany</div>
                                </div>
                                <div className="align-self-center">
                                    <img src={p_quality} className="w-75" alt="Quality"/>
                                </div>
                            </Link>
                        </div>
                        
                    </div>
                    <div className="col-md-5 col-4">
                        <img src={p_display_dollar} className="w-100" alt="example display"/>
                    </div>
                    {/* <div className="ms-2 position-relative">
                        <img src={p_splitdisp} className="" style={{ width: "82%" }} alt="splitted display"/>
                        <div className="d-flex justify-content-center mb-3 btn border-secondary btn-light w-50 position-absolute top-0 end-0 mt-n4">
                            <div className="ms-n1 my-n1 align-self-center fs-8 fw-bold schum-color">
                                <div>Quality Controlled by Germany</div>
                            </div>
                            <div className="me-n1 my-n1">
                                <img src={p_quality} className="icon_quality" alt="Quality"/>
                            </div>
                        </div>
                    </div> */}
                    
                </div>
                <div className="d-flex justify-content-center mb-5" id="efficientlyfilled">
                    <div className='col-12 p-0'>
                        <div className='row'>
                            <div className="h4 fw-bold schum-color">Efficiently filled, packed & loaded</div>
                        </div>
                        <div className='row'>
                            <div className='col-sm-6'>
                                <img src={p_effpacked_disp} className="img-fluid" alt="single display sizes"/>
                            </div>
                            <div className='col-sm-6'>
                                <p>One display sitting on plastic pallets consists of 40 boxes for 40 (or more)
                                different items. 20 boxes on the front an 20 boxes on the back.</p>
                                <img src={p_effpacked_contdisp} className="w-100" alt="single display sizes"/>
                                <p>No waste of space. 50 Displays fit just perfectly inside one 40'HQ container.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center mb-5" id="youchoose">
                    <div className='col-12 p-0'>
                        <div className='row'>
                            <div className="h4 fw-bold schum-color">Huge available assortment</div>
                        </div>
                        <div className='row'>
                            <p>Benefit from a huge and ever-changing assortment. We offer highly saleable items from our current 
                            production to be retailed under your ODM (Original Design Manufacturer). We are happy to guide you 
                            with selections and ideas based on our vast experience for your retail outlet.</p>
                            <img src={p_youchoose_prodcat} className="img-fluid" alt="Choose from product categories"/>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center mb-5" id="choosefrom">
                    <div className='col-12 p-0'>
                        <div className='row'>
                            <div className="h4 fw-bold schum-color">Choose from 1000s of items</div>
                        </div>
                        <div className='row'>
                            <div className='row'>
                                <p className="col-md-6">With our fixed price concept there is no need to waste hours and days to negotiate the right 
                                price for each item. Simply choose your items and instantly get the full value of every display. 
                                With suggested fixed retail price and the huge selection of thousands of items we guarantee 
                                a sales success.</p>
                                <p className="col-md-6">Simply tick your desired items and send us your inquiry by telling us the item numbers.<br/>
                                Within 48 hours you will receive a quotation with the necessary information for your order placement.</p>
                            </div>
                            <img src={p_choosefrom1000_prodall} className="img-fluid" alt="1000s of items"/>
                        </div>
                    </div>
                </div>
                {/* <div className="d-flex justify-content-start mb-5">
                    <img src={p_quality} className="" style={{ width: "15%" }} alt="half and full display"/>
                </div> */}
            </div>
        </div>
    );
}

if (document.getElementById('startpage-content')) {
    const container = document.getElementById('startpage-content');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<StartpageContent />);
}